import { render, staticRenderFns } from "./ResultConfirm.vue?vue&type=template&id=52b6ec4c&"
import script from "./ResultConfirm.vue?vue&type=script&lang=js&"
export * from "./ResultConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ResultConfirm.vue?vue&type=style&index=0&id=52b6ec4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports